import React from 'react';
import { MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
interface CtaButtonProps {
  text: string;
  className?: string;
  variant?: 'solid' | 'outline';
}
export function CtaButton({
  text,
  className = '',
  variant = 'solid'
}: CtaButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center gap-3 px-8 py-4 rounded-sm font-serif text-lg tracking-wide transition-all duration-500 ease-out';
  const variants = {
    solid: 'bg-gradient-to-r from-[#25D366] to-[#128C7E] text-white hover:shadow-[0_0_24px_rgba(37,211,102,0.5)] hover:scale-[1.02] border border-[#25D366]/60',
    outline: 'border-2 border-[#25D366] text-[#25D366] hover:bg-[#25D366] hover:text-white hover:shadow-[0_0_20px_rgba(37,211,102,0.35)]'
  };
  const handleClick = () => {
    // Track Meta Pixel Lead event with button context
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'Lead', {
        content_name: text,
        content_category: 'WhatsApp CTA'
      });
      (window as any).fbq('track', 'Contact');
    }
  };
  return <motion.a href="https://wa.me/message/C5P6OYRK3Y5EP1" target="_blank" rel="noopener noreferrer" onClick={handleClick} className={`${baseStyles} ${variants[variant]} ${className}`} whileHover={{
    y: -2
  }} whileTap={{
    scale: 0.98
  }} data-id="element-215">
      <MessageCircle className="w-5 h-5" data-id="element-216" />
      <span data-id="element-217">{text}</span>
    </motion.a>;
}